import type { RouteLocationNormalized } from "vue-router"

import * as campaignThresholdConfigurationApi from "@/api/campaignThresholdConfiguration/api.js"
import * as sendingConfigurationApi from "@/api/sendingConfiguration/api.js"
import DefaultLayout from "@/layouts/DefaultLayout/DefaultLayout.vue"
import { setRouteParam } from "@/types/routerPrefetch"
import createAuthRouteMeta from "@/utils/createAuthRouteMeta"
import PERMISSIONS from "@/utils/permissions/index.js"

export default [
    {
        path: "/platform-settings",
        component: DefaultLayout,
        name: "platform-settings",
        redirect: () => {
            return { name: "channel-management" }
        },
        meta: {
            isShow: false,
            name: "平台設定",
            menuGroup: "platform-settings",
        },
        children: [
            // 通道管理
            {
                path: "channel-management",
                name: "channel-management",
                redirect: () => {
                    return { name: "data-channel-settings" }
                },
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.VIEW_CHANNEL_MANAGEMENT],
                    isSubShow: true,
                    subIndex: "1",
                    subGroup: "channel-management",
                    hasSubMenuGroup: true,
                    subMenuGroup: "通道管理",
                    subMenuGroupIndex: "1",
                },
                children: [
                    // 資料通道串接管理
                    {
                        path: "data",
                        name: "data-channel-settings",
                        component: () => import("@/pages/PlatformSettingsGroup/ChannelSettingsPage.vue"),
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_CHANNEL_MANAGEMENT],
                            isSubShow: true,
                            subIndex: "1-1",
                            subGroup: "channel-management",
                            subGroupName: "資料通道串接管理",
                        },
                        props: { serviceType: "data" },
                    },
                    // 接觸通道串接管理
                    {
                        path: "messaging",
                        name: "messaging-channel-settings",
                        component: () => import("@/pages/PlatformSettingsGroup/ChannelSettingsPage.vue"),
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_CHANNEL_MANAGEMENT],
                            isSubShow: true,
                            subIndex: "1-2",
                            subGroup: "channel-management",
                            subGroupName: "接觸通道串接管理",
                        },
                        props: { serviceType: "messaging" },
                    },
                    // 通道配置頁
                    {
                        path: ":serviceType/config",
                        name: "channel-configuration",
                        component: () => import("@/pages/PlatformSettingsGroup/ChannelConfigurationPage.vue"),
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.EDIT_CHANNEL_MANAGEMENT],
                            isSubShow: false,
                            subGroup: "channel-management",
                            subGroupName: "通道串接管理",
                        },
                    },
                    // 通道紀錄頁
                    {
                        path: ":serviceType/records",
                        name: "channel-records",
                        component: () => import("@/pages/PlatformSettingsGroup/ChannelRecordsPage.vue"),
                        meta: {
                            requiresAuth: true,
                            permissions: [PERMISSIONS.VIEW_CHANNEL_MANAGEMENT_DETAIL],
                            isSubShow: false,
                            subGroup: "channel-management",
                            subGroupName: "通道串接管理",
                        },
                    },
                ],
            },
            // 平台管理
            {
                path: "",
                name: "platform-management",
                redirect: () => {
                    return { name: "sending-configuration" }
                },
                meta: {
                    requiresAuth: true,
                    permissions: [PERMISSIONS.VIEW_PLATFORM_MANAGEMENT],
                    isSubShow: true,
                    subIndex: "2",
                    subGroup: "platform-management",
                    hasSubMenuGroup: true,
                    subMenuGroup: "平台管理",
                    subMenuGroupIndex: "2",
                },
                children: [
                    {
                        path: "sending-configuration",
                        name: "sending-configuration",
                        component: () => import("@/pages/PlatformSettingsGroup/SendingConfiguration.vue"),
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.VIEW_PLATFORM_MANAGEMENT],
                            isSubShow: true,
                            subIndex: "2-1",
                            subGroupName: "預覽與寄件人管理",
                            alternativeGroup: "platform-management",
                        }),
                        props: true,
                        beforeEnter: async (to: RouteLocationNormalized) => {
                            try {
                                const response = await sendingConfigurationApi.getSendingConfiguration()
                                setRouteParam(to.params, "initialConfigurationResponse", response)
                                return true
                            } catch (error) {
                                console.error(error)
                                return false
                            }
                        },
                    },
                    {
                        path: "campaign-threshold-configuration",
                        name: "campaign-threshold-configuration",
                        component: () => import("@/pages/PlatformSettingsGroup/CampaignThresholdConfiguration.vue"),
                        meta: createAuthRouteMeta({
                            permissions: [PERMISSIONS.VIEW_PLATFORM_MANAGEMENT],
                            isSubShow: true,
                            subIndex: "2-2",
                            subGroupName: "系統閾值設定",
                            alternativeGroup: "platform-management",
                        }),
                        props: true,
                        beforeEnter: async (to: RouteLocationNormalized) => {
                            try {
                                const response =
                                    await campaignThresholdConfigurationApi.getCampaignThresholdConfiguration()
                                setRouteParam(to.params, "initialConfigurationResponse", response)
                                return true
                            } catch (error) {
                                console.error(error)
                                return false
                            }
                        },
                    },
                ],
            },
        ],
    },
]
